import React from 'react';
import { MenuItem, Typography } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { useNavigate } from 'react-router-dom';

export type MenuAccessToDossierCollectionType = {
    dossierCollectionId: number;
    dossierCollectionBasePath: string;
};
const MenuAccessToDossierCollection: React.FunctionComponent<MenuAccessToDossierCollectionType> =
    function ({ dossierCollectionId, dossierCollectionBasePath = 'commandes' }) {
        const navigate = useNavigate();

        const handleDossierLinkClick = () => {
            navigate(`/${dossierCollectionBasePath}/${dossierCollectionId}`);
        };

        return (
            <MenuItem
                sx={{ gap: '4px' }}
                onClick={handleDossierLinkClick}
            >
                <FaOptionIcon
                    icon={['fasl', 'folder-tree']}
                    color="text.gris70"
                />
                <Typography sx={{ color: 'text.primary' }}>Accéder à la commande</Typography>
            </MenuItem>
        );
    };

export default MenuAccessToDossierCollection;
